import NewsDetailLayout from '../NewsDetailLayout';
import { awaseruData } from '../newsDetailData';

const AwaseruDetail = () => <NewsDetailLayout data={awaseruData} />;
export default AwaseruDetail;
